import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";
import Select from "react-select";

import { AntpsicologicosUpdate } from "./AntpsicologicosUpdate";
import { AntpsicologicosDelete } from "./AntpsicologicosDelete";

export function AntpsicologicosEdit(props) {
  const antpsicologicos = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = antpsicologicos.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [antpsicResp, setAntpsicResp] = useState(
    antpsicologicos.meta?.antpsicResp
  );
  const [antpsicFecha, setAntpsicFecha] = useState(
    antpsicologicos.meta?.metaFecha
  );
  const [antpsicTipo, setAntpsicTipo] = useState(
    antpsicologicos.meta?.antpsicTipo || "Ingreso"
  );

  const [antpsicTratprevRad, setAntpsicTratprevRad] = useState(
    antpsicologicos.meta?.antpsicTratprevRad
  );
  const [antpsicTratPrevRep, setAntpsicTratPrevRep] = useState(
    antpsicologicos.meta?.antpsicTratPrevRep
  );
  const [antpsicAfam, setAntpsicAfam] = useState(
    antpsicologicos.meta?.antpsicAfam
  );
  const [antpsicPfamRad, setAntpsicPfamRad] = useState(
    antpsicologicos.meta?.antpsicPfamRad
  );
  const [antpsicPfamEsp, setAntpsicPfamEsp] = useState(
    antpsicologicos.meta?.antpsicPfamEsp
  );
  const [antpsicPsocRad, setAntpsicPsocRad] = useState(
    antpsicologicos.meta?.antpsicPsocRad
  );
  const [antpsicPsocEsp, setAntpsicPsocEsp] = useState(
    antpsicologicos.meta?.antpsicPsocEsp
  );
  const [antpsicPlegRad, setAntpsicPlegRad] = useState(
    antpsicologicos.meta?.antpsicPlegRad
  );
  const [antpsicPlegEsp, setAntpsicPlegEsp] = useState(
    antpsicologicos.meta?.antpsicPlegEsp
  );
  const [antpsicPlabRad, setAntpsicPlabRad] = useState(
    antpsicologicos.meta?.antpsicPlabRad
  );
  const [antpsicPlabEsp, setAntpsicPlabEsp] = useState(
    antpsicologicos.meta?.antpsicPlabEsp
  );
  const [antpsicActtrat, setAntpsicActtrat] = useState(
    antpsicologicos.meta?.antpsicActtrat
  );
  const [antpsicRelinterpfam, setAntpsicRelinterpfam] = useState(
    antpsicologicos.meta?.antpsicRelinterpfam
  );
  const [antpsicRelinterptrab, setAntpsicRelinterptrab] = useState(
    antpsicologicos.meta?.antpsicRelinterptrab
  );
  const [antpsicRelinterpoc, setAntpsicRelinterpoc] = useState(
    antpsicologicos.meta?.antpsicRelinterpoc
  );
  const [antpsicVivadic, setAntpsicVivadic] = useState(
    antpsicologicos.meta?.antpsicVivadic
  );
  const [antpsicFampsiq, setAntpsicFampsiq] = useState(
    antpsicologicos.meta?.antpsicFampsiq
  );
  const [antpsicRelpadre, setAntpsicRelpadre] = useState(
    antpsicologicos.meta?.antpsicRelpadre
  );
  const [antpsicRelmadre, setAntpsicRelmadre] = useState(
    antpsicologicos.meta?.antpsicRelmadre
  );
  const [antpsicRelherm, setAntpsicRelherm] = useState(
    antpsicologicos.meta?.antpsicRelherm
  );
  const [antpsicRelpareja, setAntpsicRelpareja] = useState(
    antpsicologicos.meta?.antpsicRelpareja
  );
  const [antpsicRelhij, setAntpsicRelhij] = useState(
    antpsicologicos.meta?.antpsicRelhij
  );
  const [antpsicConvivact, setAntpsicConvivact] = useState(
    antpsicologicos.meta?.antpsicConvivact
  );
  const [antpsicEstciv, setAntpsicEstciv] = useState(
    antpsicologicos.meta?.antpsicEstciv
  );
  const [antpsicManutRad, setAntpsicManutRad] = useState(
    antpsicologicos.meta?.antpsicManutRad
  );
  const [antpsicManutEsp, setAntpsicManutEsp] = useState(
    antpsicologicos.meta?.antpsicManutEsp
  );
  const [antpsicExptrabaj, setAntpsicExptrabaj] = useState(
    antpsicologicos.meta?.antpsicExptrabaj
  );
  const [antpsicTrabaj, setAntpsicTrabaj] = useState(
    antpsicologicos.meta?.antpsicTrabaj
  );
  const [antpsicEstlabact, setAntpsicEstlabact] = useState(
    antpsicologicos.meta?.antpsicEstlabact
  );
  const [antpsicEduc, setAntpsicEduc] = useState(
    antpsicologicos.meta?.antpsicEduc
  );
  const [antpsicProfRad, setAntpsicProfRad] = useState(
    antpsicologicos.meta?.antpsicProfRad
  );
  const [antpsicProfEsp, setAntpsicProfEsp] = useState(
    antpsicologicos.meta?.antpsicProfEsp
  );
  const [antpsicTrafdrogRad, setAntpsicTrafdrogRad] = useState(
    antpsicologicos.meta?.antpsicTrafdrogRad
  );
  const [antpsicTrafdorgEsp, setAntpsicTrafdorgEsp] = useState(
    antpsicologicos.meta?.antpsicTrafdorgEsp
  );
  const [antpsicJuicRad, setAntpsicJuicRad] = useState(
    antpsicologicos.meta?.antpsicJuicRad
  );
  const [antpsicJuicEsp, setAntpsicJuicEsp] = useState(
    antpsicologicos.meta?.antpsicJuicEsp
  );
  const [antpsicCarcRad, setAntpsicCarcRad] = useState(
    antpsicologicos.meta?.antpsicCarcRad
  );
  const [antpsicCarcEsp, setAntpsicCarcEsp] = useState(
    antpsicologicos.meta?.antpsicCarcEsp
  );
  const [antpsicArrestRad, setAntpsicArrestRad] = useState(
    antpsicologicos.meta?.antpsicArrestRad
  );
  const [antpsicArrestEsp, setAntpsicArrestEsp] = useState(
    antpsicologicos.meta?.antpsicArrestEsp
  );
  const [antpsicSuicRad, setAntpsicSuicRad] = useState(
    antpsicologicos.meta?.antpsicSuicRad
  );
  const [antpsicSuicEsp, setAntpsicSuicEsp] = useState(
    antpsicologicos.meta?.antpsicSuicEsp
  );
  const [antpsicAlucRad, setAntpsicAlucRad] = useState(
    antpsicologicos.meta?.antpsicAlucRad
  );
  const [antpsicAlucEsp, setAntpsicAlucEsp] = useState(
    antpsicologicos.meta?.antpsicAlucEsp
  );
  const [antpsicApanRad, setAntpsicApanRad] = useState(
    antpsicologicos.meta?.antpsicApanRad
  );
  const [antpsicApanEsp, setAntpsicApanEsp] = useState(
    antpsicologicos.meta?.antpsicApanEsp
  );
  const [antpsicConvulRad, setAntpsicConvulRad] = useState(
    antpsicologicos.meta?.antpsicConvulRad
  );
  const [antpsicConvulEsp, setAntpsicConvulEsp] = useState(
    antpsicologicos.meta?.antpsicConvulEsp
  );
  const [antpsicPerdconcRad, setAntpsicPerdconcRad] = useState(
    antpsicologicos.meta?.antpsicPerdconcRad
  );
  const [antpsicPerdconcEsp, setAntpsicPerdconcEsp] = useState(
    antpsicologicos.meta?.antpsicPerdconcEsp
  );
  const [antpsicAmnlacRad, setAntpsicAmnlacRad] = useState(
    antpsicologicos.meta?.antpsicAmnlacRad
  );
  const [antpsicAmnlacEsp, setAntpsicAmnlacEsp] = useState(
    antpsicologicos.meta?.antpsicAmnlacEsp
  );
  const [antpsicPensparanRad, setAntpsicPensparanRad] = useState(
    antpsicologicos.meta?.antpsicPensparanRad
  );
  const [antpsicPensparanEsp, setAntpsicPensparanEsp] = useState(
    antpsicologicos.meta?.antpsicPensparanEsp
  );
  const [antpsicTratpsicofRad, setAntpsicTratpsicofRad] = useState(
    antpsicologicos.meta?.antpsicTratpsicofRad
  );
  const [antpsicTratpsicofEsp, setAntpsicTratpsicofEsp] = useState(
    antpsicologicos.meta?.antpsicTratpsicofEsp
  );
  const [antpsicTratpsiqRad, setAntpsicTratpsiqRad] = useState(
    antpsicologicos.meta?.antpsicTratpsiqRad
  );
  const [antpsicTratpsiqEsp, setAntpsicTratpsiqEsp] = useState(
    antpsicologicos.meta?.antpsicTratpsiqEsp
  );
  const [antpsicTerapdist, setAntpsicTerapdist] = useState(
    antpsicologicos.meta?.antpsicTerapdist
  );
  const [antpsicTerapcolabRad, setAntpsicTerapcolabRad] = useState(
    antpsicologicos.meta?.antpsicTerapcolabRad
  );
  const [antpsicAnamnesis, setAntpsicAnamnesis] = useState(
    antpsicologicos.meta?.antpsicAnamnesis
  );
  const [antpsicEntfamiliar, setAntpsicEntfamiliar] = useState(
    antpsicologicos.meta?.antpsicEntfamiliar
  );
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let antpsicologicosId = antpsicologicos.id;

  const antpsicTratPrevRepOpt = [
    { value: "Hospitalaria", label: "Hospitalaria" },
    { value: "Ambulatoria", label: "Ambulatoria" },
    { value: "Comunidad terapéutica", label: "Comunidad terapéutica" },
    { value: "Metadona", label: "Metadona" },
    { value: "Antagonistas", label: "Antagonistas" },
    { value: "Granja", label: "Granja" },
    { value: "Sin ayuda especializada", label: "Sin ayuda especializada" },
    { value: "Otros", label: "Otros" },
  ];

  const handleAntpsicTratPrevRepChange = (event, index) => {
    let data = [...antpsicTratPrevRep];
    data[index][event.target.name] = event.target.value;
    setAntpsicTratPrevRep(data);
  };

  const handleAntpsicTratPrevRepChangeSelect = (event, index) => {
    console.log(event, index);
    let data = [...antpsicTratPrevRep];
    // console.log(event.target.name)
    data[index]["modalidad"] = event;
    setAntpsicTratPrevRep(data);
  };

  const addAntpsicTratPrevRep = (e) => {
    e.preventDefault();
    let object = {
      fechaentrada: "",
      motivosalida: "",
      diaspermanencia: "",
      diasabstinencia: "",
      modalidad: "",
    };

    setAntpsicTratPrevRep([...antpsicTratPrevRep, object]);
  };

  const removeFields = (event, index) => {
    event.preventDefault();
    let data = [...antpsicTratPrevRep];
    data.splice(index, 1);
    setAntpsicTratPrevRep(data);
  };

  const antpsicDate = new Date(antpsicologicos.date);
  const diffDate = Math.abs(new Date() - antpsicDate) / 36e5;

  const submitAntpsicologicos = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await AntpsicologicosUpdate(
        antpsicResp,
        antpsicFecha,
        antpsicTipo,
        antpsicTratprevRad,
        antpsicTratPrevRep,
        antpsicAfam,
        antpsicPfamRad,
        antpsicPfamEsp,
        antpsicPsocRad,
        antpsicPsocEsp,
        antpsicPlegRad,
        antpsicPlegEsp,
        antpsicPlabRad,
        antpsicPlabEsp,
        antpsicActtrat,
        antpsicRelinterpfam,
        antpsicRelinterptrab,
        antpsicRelinterpoc,
        antpsicVivadic,
        antpsicFampsiq,
        antpsicRelpadre,
        antpsicRelmadre,
        antpsicRelherm,
        antpsicRelpareja,
        antpsicRelhij,
        antpsicConvivact,
        antpsicEstciv,
        antpsicManutRad,
        antpsicManutEsp,
        antpsicExptrabaj,
        antpsicTrabaj,
        antpsicEstlabact,
        antpsicEduc,
        antpsicProfRad,
        antpsicProfEsp,
        antpsicTrafdrogRad,
        antpsicTrafdorgEsp,
        antpsicJuicRad,
        antpsicJuicEsp,
        antpsicCarcRad,
        antpsicCarcEsp,
        antpsicArrestRad,
        antpsicArrestEsp,
        antpsicSuicRad,
        antpsicSuicEsp,
        antpsicAlucRad,
        antpsicAlucEsp,
        antpsicApanRad,
        antpsicApanEsp,
        antpsicConvulRad,
        antpsicConvulEsp,
        antpsicPerdconcRad,
        antpsicPerdconcEsp,
        antpsicAmnlacRad,
        antpsicAmnlacEsp,
        antpsicPensparanRad,
        antpsicPensparanEsp,
        antpsicTratpsicofRad,
        antpsicTratpsicofEsp,
        antpsicTratpsiqRad,
        antpsicTratpsiqEsp,
        antpsicTerapdist,
        antpsicTerapcolabRad,
        antpsicAnamnesis,
        antpsicEntfamiliar,
        tratamientoId,
        pacienteId,
        antpsicologicosId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/antecedentes/psicologicos/${antpsicologicosId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await AntpsicologicosDelete(antpsicologicosId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        {antpsicologicos.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id="formUpdatelement" onSubmit={submitAntpsicologicos}>
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="antpsicResp">Responsable</label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicResp"
                      required
                      type="text"
                      value={antpsicResp}
                      onChange={(e) => setAntpsicResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicFecha">Fecha visita</label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicFecha"
                      required
                      type="date"
                      value={antpsicFecha}
                      onChange={(e) => setAntpsicFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicTipo">Tipo</label>
                  <div className="control">
                    <div className="select">
                      <select
                        className="select"
                        id="antpsicTipo"
                        required
                        name="antpsicTipo"
                        value={antpsicTipo}
                        onChange={(e) => setAntpsicTipo(e.target.value)}
                      >
                        <option disabled value="">
                          {" "}
                          -- Selecciona una opción --
                        </option>
                        <option value="Valoración">Valoración</option>
                        <option value="Ingreso">Ingreso</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Tratamientos previos</h3>
              <div className="antpsicTratPrevRepContainer">
                <div
                  className="field key"
                  data-key={antpsicTratprevRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿El paciente ha realizado tratamientos previos?
                    </label>
                    <label className="radio" htmlFor="antpsicTratprevRadSi">
                      <input
                        id="antpsicTratprevRadSi"
                        name="antpsicTratprevRad"
                        type="radio"
                        value="Si"
                        checked={antpsicTratprevRad === "Si"}
                        onChange={(e) => setAntpsicTratprevRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicTratprevRadNo">
                      <input
                        id="antpsicTratprevRadNo"
                        name="antpsicTratprevRad"
                        type="radio"
                        value="No"
                        checked={antpsicTratprevRad === "No"}
                        onChange={(e) => setAntpsicTratprevRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>
                {/* aqui empieza el campo repetido */}

                {antpsicTratPrevRep.map((form, index) => {
                  return (
                    <div className="antpsicTratPrevRepItem lock" key={index}>
                      <div className="grid--2col">
                        <div className="field">
                          <label htmlFor="fechaentrada">Fecha de entrada</label>
                          <div className="control">
                            <input
                              className="input"
                              name="fechaentrada"
                              type="date"
                              value={form.fechaentrada}
                              onChange={(event) =>
                                handleAntpsicTratPrevRepChange(event, index)
                              }
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="motivosalida">Motivo de salida</label>
                          <div className="control">
                            <input
                              className="input"
                              name="motivosalida"
                              type="text"
                              value={form.motivosalida}
                              onChange={(event) =>
                                handleAntpsicTratPrevRepChange(event, index)
                              }
                            />
                          </div>
                        </div>
                        <div className="field">
                          <label htmlFor="diaspermanencia">
                            Tiempo de permanencia (Nº de días)
                          </label>
                          <div className="control">
                            <input
                              className="input"
                              name="diaspermanencia"
                              type="number"
                              value={form.diaspermanencia}
                              onChange={(event) =>
                                handleAntpsicTratPrevRepChange(event, index)
                              }
                            />
                          </div>
                        </div>

                        <div className="field">
                          <label htmlFor="diasabstinencia">
                            Tiempo de abstinencia (Nº de días)
                          </label>
                          <div className="control">
                            <input
                              className="input"
                              name="diasabstinencia"
                              type="number"
                              value={form.diasabstinencia}
                              onChange={(event) =>
                                handleAntpsicTratPrevRepChange(event, index)
                              }
                            />
                          </div>
                        </div>

                        <div className="field">
                          <label htmlFor="antpsicTratPrevRep">Modalidad</label>
                          <div className="control">
                            <Select
                              isMulti
                              name="colors"
                              options={antpsicTratPrevRepOpt}
                              className="basic-multi-select"
                              classNamePrefix="select"
                              placeholder="Seleccionar modalidad"
                              value={form.modalidad}
                              onChange={(event) =>
                                handleAntpsicTratPrevRepChangeSelect(
                                  event,
                                  index
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="button btn-remove is-danger is-light"
                        onClick={(event) => removeFields(event, index)}
                      >
                        Eliminar tratamiento previo
                      </button>
                    </div>
                  );
                })}
                <button
                  className="lock button btn-add is-success is-light"
                  onClick={addAntpsicTratPrevRep}
                >
                  Añadir otro tratamiento previo
                </button>

                {/* aqui termina el campo repetido */}
              </div>
              <h3>Situación familiar y social</h3>

              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="antpsicEstciv">Estado civil</label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicEstciv"
                        name="antpsicEstciv"
                        value={antpsicEstciv}
                        onChange={(e) => setAntpsicEstciv(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="soltero">Soltero</option>
                        <option value="casado">Casado</option>
                        <option value="separado">Separado</option>
                        <option value="divorciado">Divorciado</option>
                        <option value="viudo">Viudo</option>
                        <option value="otros">Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicConvivact">Convivencia actual</label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicConvivact"
                        name="antpsicConvivact"
                        value={antpsicConvivact}
                        onChange={(e) => setAntpsicConvivact(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="solo">Solo</option>
                        <option value="con-padres">Con sus padres</option>
                        <option value="con-pareja">Con su pareja</option>
                        <option value="con-pareja-hijos">
                          Con su pareja e hijos
                        </option>
                        <option value="sin-hogar">Sin hogar</option>
                        <option value="otros">Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelpadre">
                    En general ¿las relaciones con tu padre son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelpadre"
                        name="antpsicRelpadre"
                        value={antpsicRelpadre}
                        onChange={(e) => setAntpsicRelpadre(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="buenas">Buenas</option>
                        <option value="regulares">Regulares</option>
                        <option value="malas">Malas</option>
                        <option value="no-relacion">No existe relación</option>
                        <option value="no-existe-fam">
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelmadre">
                    En general ¿las relaciones con tu madre son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelmadre"
                        name="antpsicRelmadre"
                        value={antpsicRelmadre}
                        onChange={(e) => setAntpsicRelmadre(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="buenas">Buenas</option>
                        <option value="regulares">Regulares</option>
                        <option value="malas">Malas</option>
                        <option value="no-relacion">No existe relación</option>
                        <option value="no-existe-fam">
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelherm">
                    En general ¿las relaciones con tus hermanos son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelherm"
                        name="antpsicRelherm"
                        value={antpsicRelherm}
                        onChange={(e) => setAntpsicRelherm(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="buenas">Buenas</option>
                        <option value="regulares">Regulares</option>
                        <option value="malas">Malas</option>
                        <option value="no-relacion">No existe relación</option>
                        <option value="no-existe-fam">
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelpareja">
                    En general ¿las relaciones con tu pareja son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelpareja"
                        name="antpsicRelpareja"
                        value={antpsicRelpareja}
                        onChange={(e) => setAntpsicRelpareja(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="buenas">Buenas</option>
                        <option value="regulares">Regulares</option>
                        <option value="malas">Malas</option>
                        <option value="no-relacion">No existe relación</option>
                        <option value="no-existe-fam">
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelhij">
                    En general ¿las relaciones con tus hijos son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelhij"
                        name="antpsicRelhij"
                        value={antpsicRelhij}
                        onChange={(e) => setAntpsicRelhij(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="buenas">Buenas</option>
                        <option value="regulares">Regulares</option>
                        <option value="malas">Malas</option>
                        <option value="no-relacion">No existe relación</option>
                        <option value="no-existe-fam">
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicFampsiq">
                    ¿Alguno de sus familiares ha tenido problemas psiquiátricos
                    o relacionados con alcohol, drogas y/o juegos que le hayan
                    llevado a tratamiento?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicFampsiq"
                        name="antpsicFampsiq"
                        value={antpsicFampsiq}
                        onChange={(e) => setAntpsicFampsiq(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="no">No</option>
                        <option value="si-tox">Sí, toxicomanía</option>
                        <option value="si-psiq">Sí, psiquiátricos</option>
                        <option value="no-sabe">No sabe</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicVivadic">
                    ¿Vive o ha vivido con alguien que tenga algún tipo de
                    adicción?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicVivadic"
                        name="antpsicVivadic"
                        value={antpsicVivadic}
                        onChange={(e) => setAntpsicVivadic(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="no">No</option>
                        <option value="si-pasad">Sí, en el pasado</option>
                        <option value="si-act">Sí, en la actualidad</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelinterpfam">
                    ¿Sus relaciones interpersonales (Familia) son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelinterpfam"
                        name="antpsicRelinterpfam"
                        value={antpsicRelinterpfam}
                        onChange={(e) => setAntpsicRelinterpfam(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="no-exist">
                          No existe ese grupo de referencia
                        </option>
                        <option value="no-consum">No consumidores</option>
                        <option value="consum">Consumidores</option>
                        <option value="ex-cosum">Ex-consumidores</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelinterptrab">
                    ¿Sus relaciones interpersonales (Trabajo) son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelinterptrab"
                        name="antpsicRelinterptrab"
                        value={antpsicRelinterptrab}
                        onChange={(e) =>
                          setAntpsicRelinterptrab(e.target.value)
                        }
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="no-exist">
                          No existe ese grupo de referencia
                        </option>
                        <option value="no-consum">No consumidores</option>
                        <option value="consum">Consumidores</option>
                        <option value="ex-cosum">Ex-consumidores</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicRelinterpoc">
                    ¿Sus relaciones interpersonales (Ocio) son…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicRelinterpoc"
                        name="antpsicRelinterpoc"
                        value={antpsicRelinterpoc}
                        onChange={(e) => setAntpsicRelinterpoc(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="no-exist">
                          No existe ese grupo de referencia
                        </option>
                        <option value="no-consum">No consumidores</option>
                        <option value="consum">Consumidores</option>
                        <option value="ex-cosum">Ex-consumidores</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicActtrat">
                    ¿El actual tratamiento fue decidido por…?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicActtrat"
                        name="antpsicActtrat"
                        value={antpsicActtrat}
                        onChange={(e) => setAntpsicActtrat(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="el-mism">El mismo</option>
                        <option value="su-fam-orig">
                          Su familia de origen
                        </option>
                        <option value="su-parej">Su pareja</option>
                        <option value="sist-jud">Sistema judicial</option>
                        <option value="otros">Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicPfamRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido preocupaciones o dificultades familiares en los
                      últimos 30 días?
                    </label>
                    <label className="radio" htmlFor="antpsicPfamRadSi">
                      <input
                        id="antpsicPfamRadSi"
                        name="antpsicPfamRad"
                        type="radio"
                        value="Si"
                        checked={antpsicPfamRad === "Si"}
                        onChange={(e) => setAntpsicPfamRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicPfamRadNo">
                      <input
                        id="antpsicPfamRadNo"
                        name="antpsicPfamRad"
                        type="radio"
                        value="No"
                        checked={antpsicPfamRad === "No"}
                        onChange={(e) => setAntpsicPfamRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicPfamEsp">
                    Especificar dificultades familiares
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicPfamEsp"
                      type="text"
                      value={antpsicPfamEsp}
                      onChange={(e) => setAntpsicPfamEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicPsocRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido preocupaciones o dificultades sociales en los
                      últimos 30 días?
                    </label>
                    <label className="radio" htmlFor="antpsicPsocRadSi">
                      <input
                        id="antpsicPsocRadSi"
                        name="antpsicPsocRad"
                        type="radio"
                        value="Si"
                        checked={antpsicPsocRad === "Si"}
                        onChange={(e) => setAntpsicPsocRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicPsocRadNo">
                      <input
                        id="antpsicPsocRadNo"
                        name="antpsicPsocRad"
                        type="radio"
                        value="No"
                        checked={antpsicPsocRad === "No"}
                        onChange={(e) => setAntpsicPsocRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicPsocEsp">
                    Especificar dificultades sociales
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicPsocEsp"
                      type="text"
                      value={antpsicPsocEsp}
                      onChange={(e) => setAntpsicPsocEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicPlegRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido preocupaciones o dificultades legales en los
                      últimos 30 días?
                    </label>
                    <label className="radio" htmlFor="antpsicPlegRadSi">
                      <input
                        id="antpsicPlegRadSi"
                        name="antpsicPlegRad"
                        type="radio"
                        value="Si"
                        checked={antpsicPlegRad === "Si"}
                        onChange={(e) => setAntpsicPlegRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicPlegRadNo">
                      <input
                        id="antpsicPlegRadNo"
                        name="antpsicPlegRad"
                        type="radio"
                        value="No"
                        checked={antpsicPlegRad === "No"}
                        onChange={(e) => setAntpsicPlegRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicPlegEsp">
                    Especificar dificultades legales
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicPlegEsp"
                      type="text"
                      value={antpsicPlegEsp}
                      onChange={(e) => setAntpsicPlegEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicPlabRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido preocupaciones o dificultades laborales en los
                      últimos 30 días?
                    </label>
                    <label className="radio" htmlFor="antpsicPlabRadSi">
                      <input
                        id="antpsicPlabRadSi"
                        name="antpsicPlabRad"
                        type="radio"
                        value="Si"
                        checked={antpsicPlabRad === "Si"}
                        onChange={(e) => setAntpsicPlabRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicPlabRadNo">
                      <input
                        id="antpsicPlabRadNo"
                        name="antpsicPlabRad"
                        type="radio"
                        value="No"
                        checked={antpsicPlabRad === "No"}
                        onChange={(e) => setAntpsicPlabRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicPlabEsp">
                    Especificar dificultades laborales
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicPlabEsp"
                      type="text"
                      value={antpsicPlabEsp}
                      onChange={(e) => setAntpsicPlabEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicAfam">
                    ¿Dispone de apoyo para el tratamiento?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicAfam"
                        name="antpsicAfam"
                        value={antpsicAfam}
                        onChange={(e) => setAntpsicAfam(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="apoy-fam">Apoyo de familiares</option>
                        <option value="apoy-amig">Apoyo de amigos</option>
                        <option value="apoy-fam-amig">
                          Apoyo de familiares y amigos
                        </option>
                        <option value="no-apoy">
                          No dispone de ningún apoyo
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Situación laboral</h3>
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="antpsicEduc">Educación</label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicEduc"
                        name="antpsicEduc"
                        value={antpsicEduc}
                        onChange={(e) => setAntpsicEduc(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="analf">Analfabeto</option>
                        <option value="est-basic">Estudios básicos</option>
                        <option value="egb-eso">EGB/ESO</option>
                        <option value="bup-cou">BUP/COU</option>
                        <option value="fp">FP</option>
                        <option value="diplom">Diplomatura</option>
                        <option value="licenc">Licenciatura</option>
                        <option value="otros">Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicExptrabaj">
                    Expectativa de trabajo
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicExptrabaj"
                        name="antpsicExptrabaj"
                        value={antpsicExptrabaj}
                        onChange={(e) => setAntpsicExptrabaj(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="sin-expt">Sin expectativas</option>
                        <option value="mant-trabj-act">
                          Mantener su trabajo actual
                        </option>
                        <option value="camb-trabj">Cambiar de trabajo</option>
                        <option value="comenz-trabj">
                          Comenzar a trabajar
                        </option>
                        <option value="perm-baja">Permanecer de baja</option>
                        <option value="otros">Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicTrabaj">Trabaja</label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicTrabaj"
                        name="antpsicTrabaj"
                        value={antpsicTrabaj}
                        onChange={(e) => setAntpsicTrabaj(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="cuent-ajen">Por cuenta ajena</option>
                        <option value="neg-prop">Negocio propio</option>
                        <option value="neg-fam">Negocio familiar</option>
                        <option value="no-trabj">No tiene trabajo</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="antpsicEstlabact">
                    Estado laboral actual
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicEstlabact"
                        name="antpsicEstlabact"
                        value={antpsicEstlabact}
                        onChange={(e) => setAntpsicEstlabact(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="fijo">Fijo</option>
                        <option value="temporal">Temporal</option>
                        <option value="en-paro">En paro</option>
                        <option value="baja-incapac">
                          De baja/incapacidad
                        </option>
                        <option value="estudiante">Estudiante</option>
                        <option value="ama-casa">Ama de casa</option>
                        <option value="jubilado">Jubilado</option>
                        <option value="otros">Otros</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  className="field key"
                  data-key={antpsicProfRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Tiene alguna profesión u oficio?
                    </label>
                    <label className="radio" htmlFor="antpsicProfRadSi">
                      <input
                        id="antpsicProfRadSi"
                        name="antpsicProfRad"
                        type="radio"
                        value="Si"
                        checked={antpsicProfRad === "Si"}
                        onChange={(e) => setAntpsicProfRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicProfRadNo">
                      <input
                        id="antpsicProfRadNo"
                        name="antpsicProfRad"
                        type="radio"
                        value="No"
                        checked={antpsicProfRad === "No"}
                        onChange={(e) => setAntpsicProfRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicProfEsp">Especificar oficio</label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicProfEsp"
                      type="text"
                      value={antpsicProfEsp}
                      onChange={(e) => setAntpsicProfEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicManutRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Contribuye alguien en su manutención?
                    </label>
                    <label className="radio" htmlFor="antpsicManutRadSi">
                      <input
                        id="antpsicManutRadSi"
                        name="antpsicManutRad"
                        type="radio"
                        value="Si"
                        checked={antpsicManutRad === "Si"}
                        onChange={(e) => setAntpsicManutRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicManutRadNo">
                      <input
                        id="antpsicManutRadNo"
                        name="antpsicManutRad"
                        type="radio"
                        value="No"
                        checked={antpsicManutRad === "No"}
                        onChange={(e) => setAntpsicManutRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicManutEsp">
                    Especificar manutención
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicManutEsp"
                      type="text"
                      value={antpsicManutEsp}
                      onChange={(e) => setAntpsicManutEsp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Situación legal</h3>
              <div className="grid--2col">
                <div
                  className="field key"
                  data-key={antpsicTrafdrogRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha traficado con drogas?
                    </label>
                    <label className="radio" htmlFor="antpsicTrafdrogRadSi">
                      <input
                        id="antpsicTrafdrogRadSi"
                        name="antpsicTrafdrogRad"
                        type="radio"
                        value="Si"
                        checked={antpsicTrafdrogRad === "Si"}
                        onChange={(e) => setAntpsicTrafdrogRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicTrafdrogRadNo">
                      <input
                        id="antpsicTrafdrogRadNo"
                        name="antpsicTrafdrogRad"
                        type="radio"
                        value="No"
                        checked={antpsicTrafdrogRad === "No"}
                        onChange={(e) => setAntpsicTrafdrogRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicTrafdorgEsp">
                    Especificar tráfico
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicTrafdorgEsp"
                      type="text"
                      value={antpsicTrafdorgEsp}
                      onChange={(e) => setAntpsicTrafdorgEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicJuicRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Está actualmente esperando juicio o sentencia?
                    </label>
                    <label className="radio" htmlFor="antpsicJuicRadSi">
                      <input
                        id="antpsicJuicRadSi"
                        name="antpsicJuicRad"
                        type="radio"
                        value="Si"
                        checked={antpsicJuicRad === "Si"}
                        onChange={(e) => setAntpsicJuicRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicJuicRadNo">
                      <input
                        id="antpsicJuicRadNo"
                        name="antpsicJuicRad"
                        type="radio"
                        value="No"
                        checked={antpsicJuicRad === "No"}
                        onChange={(e) => setAntpsicJuicRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicJuicEsp">Especificar sentencia</label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicJuicEsp"
                      type="text"
                      value={antpsicJuicEsp}
                      onChange={(e) => setAntpsicJuicEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicCarcRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha estado alguna vez en la cárcel?
                    </label>
                    <label className="radio" htmlFor="antpsicCarcRadSi">
                      <input
                        id="antpsicCarcRadSi"
                        name="antpsicCarcRad"
                        type="radio"
                        value="Si"
                        checked={antpsicCarcRad === "Si"}
                        onChange={(e) => setAntpsicCarcRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicCarcRadNo">
                      <input
                        id="antpsicCarcRadNo"
                        name="antpsicCarcRad"
                        type="radio"
                        value="No"
                        checked={antpsicCarcRad === "No"}
                        onChange={(e) => setAntpsicCarcRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicCarcEsp">Especificar cárcel</label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicCarcEsp"
                      type="text"
                      value={antpsicCarcEsp}
                      onChange={(e) => setAntpsicCarcEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicArrestRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha sido arrestado y/o acusado alguna vez?
                    </label>
                    <label className="radio" htmlFor="antpsicArrestRadSi">
                      <input
                        id="antpsicArrestRadSi"
                        name="antpsicArrestRad"
                        type="radio"
                        value="Si"
                        checked={antpsicArrestRad === "Si"}
                        onChange={(e) => setAntpsicArrestRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicArrestRadNo">
                      <input
                        id="antpsicArrestRadNo"
                        name="antpsicArrestRad"
                        type="radio"
                        value="No"
                        checked={antpsicArrestRad === "No"}
                        onChange={(e) => setAntpsicArrestRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicArrestEsp">Especificar arresto</label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicArrestEsp"
                      type="text"
                      value={antpsicArrestEsp}
                      onChange={(e) => setAntpsicArrestEsp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Antecedentes psiquiátricos</h3>
              <div className="grid--2col">
                <div
                  className="field key"
                  data-key={antpsicSuicRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido alguna vez intentos suicidas?
                    </label>
                    <label className="radio" htmlFor="antpsicSuicRadSi">
                      <input
                        id="antpsicSuicRadSi"
                        name="antpsicSuicRad"
                        type="radio"
                        value="Si"
                        checked={antpsicSuicRad === "Si"}
                        onChange={(e) => setAntpsicSuicRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicSuicRadNo">
                      <input
                        id="antpsicSuicRadNo"
                        name="antpsicSuicRad"
                        type="radio"
                        value="No"
                        checked={antpsicSuicRad === "No"}
                        onChange={(e) => setAntpsicSuicRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicSuicEsp">
                    Especificar intentos suicidas
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicSuicEsp"
                      type="text"
                      value={antpsicSuicEsp}
                      onChange={(e) => setAntpsicSuicEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicAlucRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido alguna vez alucinaciones?
                    </label>
                    <label className="radio" htmlFor="antpsicAlucRadSi">
                      <input
                        id="antpsicAlucRadSi"
                        name="antpsicAlucRad"
                        type="radio"
                        value="Si"
                        checked={antpsicAlucRad === "Si"}
                        onChange={(e) => setAntpsicAlucRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicAlucRadNo">
                      <input
                        id="antpsicAlucRadNo"
                        name="antpsicAlucRad"
                        type="radio"
                        value="No"
                        checked={antpsicAlucRad === "No"}
                        onChange={(e) => setAntpsicAlucRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicAlucEsp">
                    Especificar alucinaciones
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicAlucEsp"
                      type="text"
                      value={antpsicAlucEsp}
                      onChange={(e) => setAntpsicAlucEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicApanRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido alguna vez ataques de pánico?
                    </label>
                    <label className="radio" htmlFor="antpsicApanRadSi">
                      <input
                        id="antpsicApanRadSi"
                        name="antpsicApanRad"
                        type="radio"
                        value="Si"
                        checked={antpsicApanRad === "Si"}
                        onChange={(e) => setAntpsicApanRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicApanRadNo">
                      <input
                        id="antpsicApanRadNo"
                        name="antpsicApanRad"
                        type="radio"
                        value="No"
                        checked={antpsicApanRad === "No"}
                        onChange={(e) => setAntpsicApanRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicApanEsp">
                    Especificar ataques de pánico
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicApanEsp"
                      type="text"
                      value={antpsicApanEsp}
                      onChange={(e) => setAntpsicApanEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicConvulRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido alguna vez convulsiones?
                    </label>
                    <label className="radio" htmlFor="antpsicConvulRadSi">
                      <input
                        id="antpsicConvulRadSi"
                        name="antpsicConvulRad"
                        type="radio"
                        value="Si"
                        checked={antpsicConvulRad === "Si"}
                        onChange={(e) => setAntpsicConvulRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicConvulRadNo">
                      <input
                        id="antpsicConvulRadNo"
                        name="antpsicConvulRad"
                        type="radio"
                        value="No"
                        checked={antpsicConvulRad === "No"}
                        onChange={(e) => setAntpsicConvulRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicConvulEsp">
                    Especificar convulsiones
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicConvulEsp"
                      type="text"
                      value={antpsicConvulEsp}
                      onChange={(e) => setAntpsicConvulEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicPerdconcRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido alguna vez pérdidas de conciencia?
                    </label>
                    <label className="radio" htmlFor="antpsicPerdconcRadSi">
                      <input
                        id="antpsicPerdconcRadSi"
                        name="antpsicPerdconcRad"
                        type="radio"
                        value="Si"
                        checked={antpsicPerdconcRad === "Si"}
                        onChange={(e) => setAntpsicPerdconcRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicPerdconcRadNo">
                      <input
                        id="antpsicPerdconcRadNo"
                        name="antpsicPerdconcRad"
                        type="radio"
                        value="No"
                        checked={antpsicPerdconcRad === "No"}
                        onChange={(e) => setAntpsicPerdconcRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicPerdconcEsp">
                    Especificar pérdidas de conciencia
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicPerdconcEsp"
                      type="text"
                      value={antpsicPerdconcEsp}
                      onChange={(e) => setAntpsicPerdconcEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicAmnlacRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido alguna vez amnesia lacunar?
                    </label>
                    <label className="radio" htmlFor="antpsicAmnlacRadSi">
                      <input
                        id="antpsicAmnlacRadSi"
                        name="antpsicAmnlacRad"
                        type="radio"
                        value="Si"
                        checked={antpsicAmnlacRad === "Si"}
                        onChange={(e) => setAntpsicAmnlacRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicAmnlacRadNo">
                      <input
                        id="antpsicAmnlacRadNo"
                        name="antpsicAmnlacRad"
                        type="radio"
                        value="No"
                        checked={antpsicAmnlacRad === "No"}
                        onChange={(e) => setAntpsicAmnlacRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicAmnlacEsp">
                    Especificar amnesia lacunar
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicAmnlacEsp"
                      type="text"
                      value={antpsicAmnlacEsp}
                      onChange={(e) => setAntpsicAmnlacEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicPensparanRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha tenido alguna vez pensamiento paranoide?
                    </label>
                    <label className="radio" htmlFor="antpsicPensparanRadSi">
                      <input
                        id="antpsicPensparanRadSi"
                        name="antpsicPensparanRad"
                        type="radio"
                        value="Si"
                        checked={antpsicPensparanRad === "Si"}
                        onChange={(e) => setAntpsicPensparanRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicPensparanRadNo">
                      <input
                        id="antpsicPensparanRadNo"
                        name="antpsicPensparanRad"
                        type="radio"
                        value="No"
                        checked={antpsicPensparanRad === "No"}
                        onChange={(e) => setAntpsicPensparanRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicPensparanEsp">
                    Especificar pensamiento paranoide
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicPensparanEsp"
                      type="text"
                      value={antpsicPensparanEsp}
                      onChange={(e) => setAntpsicPensparanEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicTratpsicofRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Tiene o ha tenido prescrito tratamiento
                      psicofarmacológico independiente a la adicción?
                    </label>
                    <label className="radio" htmlFor="antpsicTratpsicofRadSi">
                      <input
                        id="antpsicTratpsicofRadSi"
                        name="antpsicTratpsicofRad"
                        type="radio"
                        value="Si"
                        checked={antpsicTratpsicofRad === "Si"}
                        onChange={(e) =>
                          setAntpsicTratpsicofRad(e.target.value)
                        }
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicTratpsicofRadNo">
                      <input
                        id="antpsicTratpsicofRadNo"
                        name="antpsicTratpsicofRad"
                        type="radio"
                        value="No"
                        checked={antpsicTratpsicofRad === "No"}
                        onChange={(e) =>
                          setAntpsicTratpsicofRad(e.target.value)
                        }
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicTratpsicofEsp">
                    Especificar tratamiento psicofarmacológico
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicTratpsicofEsp"
                      type="text"
                      value={antpsicTratpsicofEsp}
                      onChange={(e) => setAntpsicTratpsicofEsp(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className="field key"
                  data-key={antpsicTratpsiqRad?.toString()}
                >
                  <div className="control">
                    <label className="radio-title">
                      ¿Ha estado bajo tratamiento psiquiátrico alguna vez
                      independiente a la adicción?
                    </label>
                    <label className="radio" htmlFor="antpsicTratpsiqRadSi">
                      <input
                        id="antpsicTratpsiqRadSi"
                        name="antpsicTratpsiqRad"
                        type="radio"
                        value="Si"
                        checked={antpsicTratpsiqRad === "Si"}
                        onChange={(e) => setAntpsicTratpsiqRad(e.target.value)}
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicTratpsiqRadNo">
                      <input
                        id="antpsicTratpsiqRadNo"
                        name="antpsicTratpsiqRad"
                        type="radio"
                        value="No"
                        checked={antpsicTratpsiqRad === "No"}
                        onChange={(e) => setAntpsicTratpsiqRad(e.target.value)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="field lock">
                  <label htmlFor="antpsicTratpsiqEsp">
                    Especificar tratamiento psiquiátrico
                  </label>
                  <div className="control">
                    <input
                      className="input"
                      id="antpsicTratpsiqEsp"
                      type="text"
                      value={antpsicTratpsiqEsp}
                      onChange={(e) => setAntpsicTratpsiqEsp(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <h3>Valoración del terapeuta</h3>
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="antpsicTerapdist">
                    ¿La anterior información está significativamente
                    distorsionada?
                  </label>
                  <div className="control">
                    <div className="select">
                      <select
                        required
                        className="select"
                        id="antpsicTerapdist"
                        name="antpsicTerapdist"
                        value={antpsicTerapdist}
                        onChange={(e) => setAntpsicTerapdist(e.target.value)}
                      >
                        <option disabled value="">
                          -- Selecciona una opción --
                        </option>
                        <option value="no">No</option>
                        <option value="si-falsa">
                          Sí, por falsa declaración del paciente
                        </option>
                        <option value="si-incap">
                          Sí, por incapacidad de comprensión del paciente
                        </option>
                        <option value="si-efect">
                          Sí, por estar bajo los efectos del consumo
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="field key">
                  <div className="control">
                    <label className="radio-title">
                      Durante la entrevista ¿el paciente ha estado colaborador?
                    </label>
                    <label className="radio" htmlFor="antpsicTerapcolabRadSi">
                      <input
                        id="antpsicTerapcolabRadSi"
                        name="antpsicTerapcolabRad"
                        type="radio"
                        value="Si"
                        checked={antpsicTerapcolabRad === "Si"}
                        onChange={(e) =>
                          setAntpsicTerapcolabRad(e.target.value)
                        }
                      />
                      Si
                    </label>
                    <label className="radio" htmlFor="antpsicTerapcolabRadNo">
                      <input
                        id="antpsicTerapcolabRadNo"
                        name="antpsicTerapcolabRad"
                        type="radio"
                        value="No"
                        checked={antpsicTerapcolabRad === "No"}
                        onChange={(e) =>
                          setAntpsicTerapcolabRad(e.target.value)
                        }
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>
              <div className="field">
                <label className="label-title" htmlFor="antpsicAnamnesis">
                  Anamnesis
                </label>
                <div className="control">
                  <textarea
                    className="textarea"
                    name="antpsicAnamnesis"
                    id="antpsicAnamnesis"
                    value={antpsicAnamnesis}
                    onChange={(e) => setAntpsicAnamnesis(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="field">
                <label className="label-title" htmlFor="antpsicEntfamiliar">
                  Entrevista familiar
                </label>
                <div className="control">
                  <textarea
                    className="textarea"
                    name="antpsicEntfamiliar"
                    id="antpsicEntfamiliar"
                    value={antpsicEntfamiliar}
                    onChange={(e) => setAntpsicEntfamiliar(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
          <Link
            className="button is-link is-light"
            to={`../${tratamientoId}/antecedentes/psicologicos/${antpsicologicos.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className="button is-danger"
              id="deleteButton"
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : "Eliminar"}
            </button>
          )}
        </div>
      )}
    </>
  );
}
